import store from "@/store";

export const CustomEventMetricName = {
  VSS_PC_PAGE_VIEW: "vss-pc-page-view",
};

/**
 *
 *
 * @export
 * @param {*} {
 *     name,      // 自定义指标名称
 *     value,     // 指标值，要求类型为 number
 *     tags,      // 指标增加标签信息
 * }
 */
export function sendEventMetric({ name, value, tags }) {
  if (window.Owl) {
    const metricManager = window.Owl.metricManager;
    // 设置自定义指标数据
    metricManager.setMetric(name, value);
    // 增加维度信息
    if (tags) {
      metricManager.setTags(tags);
    }
  }
}

/**
 * 自定义业务测速指标上报
 *
 * @export
 * @param {*} {
 *     name,        // 自定义指标名称
 *     duration,    // 表示测速时间值，单位毫秒
 *     timeStamp,   // 测速时间戳，单位毫秒，默认为当前时间
 *     referTime,   // 参照时间点，单位毫秒，默认为 performance navigationStart
 *     tags,        // 指标增加标签信息
 * }
 */
export function sendTimingEventMetric({
  name,
  duration,
  timeStamp,
  referTime,
  tags,
}) {
  let value;
  if (duration) {
    value = duration;
  } else {
    value =
      (timeStamp || new Date()) -
      (referTime || window.performance.timing.navigationStart);
  }
  sendEventMetric({
    name,
    value,
    tags,
  });
}

export function sendAllPageViewEventMetric() {
  const currentState = store.state;
  sendTimingEventMetric({
    name: CustomEventMetricName.VSS_PC_PAGE_VIEW,
    referTime: +new Date(),
    tags: {
      merchant_account_id: currentState.accountInfo.login,
      vss_page_url: window.location.href,
      supplier_name: currentState.supplierInfo.supplierName,
      supplier_id: currentState.supplierInfo.supplierId,
    },
  });
}
